import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CarPartListItem from './CarPartListItem';
import { LoadingButton } from './Buttons';
import breakpoints from '../styles/breakpoints';

const StyledCarPartsList = styled.div`
  margin: 0;
`;

const Total = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.57;
  letter-spacing: 0.1px;
  margin-bottom: 5px;

  ${breakpoints.large`
		text-align: right;
	`};
`;

const List = styled.div`
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;

  ${breakpoints.medium`
		margin: 0 -${p => p.theme.gutterSmall};
	`};

  ${breakpoints.large`
		display: block;
		border-top: 1px solid ${p => p.theme.colors.border};
	`};
`;

const LoadMoreButton = styled(LoadingButton)`
  display: block;
  margin: 40px auto 40px auto;
`;

export default function CarPartsList({
  carParts,
  total,
  hasMore,
  loading,
  onLoadMore
}) {
  return (
    <StyledCarPartsList>
      <Total>Antall treff: {total ? total.toLocaleString('nb-NO') : 0}</Total>

      <List>
        {carParts.map(carPart => (
          <CarPartListItem key={carPart.id} carPart={carPart} />
        ))}
      </List>

      {hasMore && (
        <LoadMoreButton onClick={onLoadMore} loading={loading}>
          Last flere deler…
        </LoadMoreButton>
      )}
    </StyledCarPartsList>
  );
}

CarPartsList.propTypes = {
  carParts: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired
};
